import { Pipe, PipeTransform } from '@angular/core';

import { staticColumnWidth } from './column-width-utils';
import { SelectOptionMobile } from '@shared/models/catalog.service';
import { CatalogItemValue } from 'app/modules/data/models/catalog';

@Pipe({
  name: 'firstStaticColumnWidth'
})
export class FirstStaticColumnPipe implements PipeTransform {
  public transform(
    column: SelectOptionMobile,
    data: CatalogItemValue[],
    fileColumnNames: string[],
    isGlobalIdColumn: boolean,
    breakPointScreen: number,
  ): string {
    const width = staticColumnWidth(data, column, fileColumnNames, isGlobalIdColumn, breakPointScreen);
    const margin = 16;
    return `${ width - margin }px`;
  }
}
